export default "__VITE_ASSET__CREPLvF6__"